<template>
  <div class="md-layout modal-item">
    <slot name="label"></slot>
    <label class="md-form-label" v-if="!!label" :style="{'min-width': labelweight ?labelweight+'px' :'unset'}">
      <i v-if="required" :style="{color: 'red'}">*</i>
      {{label}} 
      <!-- <template v-if="!!label.replace(/\s/,'')">:</template> -->
      <!-- <i :style="{opacity: 0}">:</i> -->
    </label>
    <div class="md-form-item" :style="flex_one?{} :{flex: 1}">
      <slot></slot>
    </div>
    <slot name="tail"></slot>
  </div>
</template>
<script>
export default {
  name: "modal-form-item",
  props: {
    flex_one: {
      type: Boolean,
      default : false,
    },
    labelweight: {
      type:Number,
      default:0,
    },
    label : {
      type: String,
      default: "",
    },
    required : {
      type : Boolean,
      default : false,
    }
  },
};
</script>

<style lang="scss" scoped>
  .md-layout{
    align-items: center;
  }
  .md-form-item {
    text-align: left;
  }
  .md-form-label i{
    display: inline-block;
    position: relative;
    top: 2px;
    height: 28px;
    line-height: 28px;
  }
  .md-form-label{
    color: #333333;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 14px;
    height: 28px;
    line-height: 28px;
    // padding-buttom: 20px ;
    padding-right: 15px !important;
    padding-left: 15px !important;
    text-align: left !important;
  }
</style>